<template>
  <div class="p-4">
    <h2 class="text-lg font-semibold mb-4">Информация о материале</h2>
    <div class="mb-4">
      <p class="text-gray-700 font-bold">Название:</p>
      <p>
        <span :class="{ 'line-through text-gray-500': material.product?.deleted_at }">{{ material.product?.name }}</span>
        <span v-if="material.product?.deleted_at" class="ml-1 text-xs text-red-600 font-medium">Удалена</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data:
      {
        type: Object,
        required: true,
      },
  },
  data() {
    return {
      localCount: this.data.count,
    };
  },
  computed: {
    material() {
      return this.data;
    }
  },
  methods: {
    saveChanges() {
      this.$emit('updateCount', this.localCount)
    }
  }
};
</script>
